/* =============================================================
   Raihan Saffron — theme.js
   Lightweight, no framework. Only DOM the theme actually uses.
   ============================================================= */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  var menuToggle = document.querySelector('.header__menu-toggle');
  var mobileMenu = document.getElementById('MobileMenu');
  var menuClose  = document.querySelector('.mobile-menu__close');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menuClose)  menuClose.addEventListener('click', closeMenu);
  if (mobileMenu) {
    mobileMenu.addEventListener('click', function (e) {
      if (e.target === mobileMenu) closeMenu();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* ---------- Quantity selectors ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus  = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap  = (minus || plus).closest('.qty');
    if (!wrap) return;
    var input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    var v = parseInt(input.value || '1', 10);
    if (minus) v = Math.max(parseInt(input.min || '1', 10), v - 1);
    if (plus)  v = v + 1;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('[data-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-src');
      var main = btn.closest('.product__gallery').querySelector('.product__media-main img');
      if (main && src) {
        main.src = src;
        main.removeAttribute('srcset');
      }
    });
  });

  /* ---------- Variant selection (no full page reload) ---------- */
  var forms = document.querySelectorAll('.product__form');
  forms.forEach(function (form) {
    var section = form.closest('[data-section-id]');
    if (!section) return;

    function getSelectedOptions() {
      var groups = form.querySelectorAll('.product__option');
      return Array.from(groups).map(function (g) {
        var checked = g.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findMatchingVariant(productData, selected) {
      if (!productData || !productData.variants) return null;
      return productData.variants.find(function (v) {
        return selected.every(function (val, i) {
          if (val == null) return true;
          return v['option' + (i + 1)] === val;
        });
      }) || null;
    }

    function updateUI(variant) {
      if (!variant) return;
      // Hidden variant id
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;

      // Selected value labels
      var groups = form.querySelectorAll('.product__option');
      groups.forEach(function (g, i) {
        var checked = g.querySelector('input[type="radio"]:checked');
        var label = g.querySelector('[data-selected-value]');
        if (checked && label) label.textContent = checked.value;
        // Active swatch state
        g.querySelectorAll('.product__swatch').forEach(function (sw) {
          var inp = sw.querySelector('input');
          sw.classList.toggle('is-active', inp && inp.checked);
        });
      });

      // Submit button availability
      var submit = form.querySelector('button[type="submit"]');
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? (submit.dataset.labelAdd || 'Add to cart') : 'Sold out';
      }
    }

    // Pull product JSON from /products/handle.json once
    var productHandle = window.location.pathname.split('/products/')[1];
    if (productHandle) {
      productHandle = productHandle.split('/')[0].split('?')[0];
      fetch('/products/' + productHandle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return;
          form.addEventListener('change', function (e) {
            if (!e.target.matches('.product__option input[type="radio"]')) return;
            var selected = getSelectedOptions();
            var v = findMatchingVariant(data, selected);
            updateUI(v);
          });
        })
        .catch(function () { /* silent */ });
    }
  });

  /* ---------- Cart count refresh after add-to-cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.product__form');
    if (!form) return;
    // Allow normal submit, then refresh count
    setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var el = document.querySelector('[data-cart-count]');
          if (el) el.textContent = cart.item_count;
        })
        .catch(function () {});
    }, 600);
  });
})();
